module.exports = __webpack_public_path__ + "img/box-clouds.0e483295.png";